const HairColorBrowser = () => import(/* webpackChunkName: "hairColorBrowser" */ './HairColorBrowser');

export default [
  { path: '/hair-color-chart',
    components: {
      default: HairColorBrowser
    },
  }
];